import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import * as PropTypes from 'prop-types';
import { numberToLocaleString } from '@shared/utils/localeUtils';
import { Image, ImageFit, mergeStyleSets, Text } from '@fluentui/react';
import { NeutralColors } from '@fluentui/theme';
const contentStyles = mergeStyleSets({
    featuredCustomer: {
        width: 240,
        height: 190,
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: NeutralColors.gray30,
        padding: 16,
        display: 'flex',
        flexDirection: 'column'
    },
    featuredCustomerLogo: {
        width: 60,
        height: 60,
        position: 'relative',
        overflow: 'hidden'
    },
    featuredCustomerLargeIcon: {
        width: 60,
        height: 60,
        position: 'relative',
        overflow: 'hidden'
    },
    featuredCustomerLargeIconImg: {
        width: '100%',
        height: '100%'
    },
    featuredCustomerNameText: {
        marginTop: 8,
        fontSize: 18,
        lineHeight: 24,
        fontWeight: 600,
        color: NeutralColors.gray160
    },
    featuredCustomerNormalText: {
        marginTop: 8,
        fontSize: 12,
        lineHeight: 16,
        fontWeight: 600,
        color: NeutralColors.gray130
    }
});
export const LinkedinFeaturedCustomer = ({ customer, locale, countryCode }, context)=>{
    const { name, logoUrl, businessCategory, followersCount } = customer;
    return /*#__PURE__*/ _jsx("div", {
        className: "featuredCustomerBox",
        children: /*#__PURE__*/ _jsxs("div", {
            className: contentStyles.featuredCustomer,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: contentStyles.featuredCustomerLogo,
                    children: /*#__PURE__*/ _jsx("div", {
                        className: contentStyles.featuredCustomerLargeIcon,
                        children: /*#__PURE__*/ _jsx(Image, {
                            imageFit: ImageFit.contain,
                            className: contentStyles.featuredCustomerLargeIconImg,
                            src: logoUrl
                        })
                    })
                }),
                /*#__PURE__*/ _jsx(Text, {
                    className: contentStyles.featuredCustomerNameText,
                    children: name
                }),
                /*#__PURE__*/ _jsx(Text, {
                    className: contentStyles.featuredCustomerNormalText,
                    children: businessCategory
                }),
                /*#__PURE__*/ _jsx(Text, {
                    className: contentStyles.featuredCustomerNormalText,
                    children: context.locParams('Linkedin_Followers_Count', [
                        numberToLocaleString({
                            number: followersCount,
                            locale,
                            countryCode
                        })
                    ])
                })
            ]
        })
    });
};
LinkedinFeaturedCustomer.contextTypes = {
    loc: PropTypes.func,
    locParams: PropTypes.func
};
